import { render, staticRenderFns } from "./videoBlock.vue?vue&type=template&id=6d66340e&scoped=true&"
import script from "./videoBlock.vue?vue&type=script&lang=js&"
export * from "./videoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d66340e",
  null
  
)

export default component.exports